import { TemplateElement, html, i18n } from '@webtides/element-js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';

import '../../../elements/price-asterisk/price-asterisk';
import CurrencyFormatter from '../../../../js/helper/currency-formatter';
import styles from './product-price.css';
import {
    getFormattedBasePrice,
    getFormattedDiscountPrice,
    getFormattedSalePrice,
    getFormattedStrikePrice,
    getSalePriceValue,
    isStrikePrice,
} from '../../../../js/helper/price-model-helper';

export default class ProductPrice extends TemplateElement {
    constructor() {
        super({ shadowRender: false, deferUpdate: true, styles: [styles] });
    }

    connected() {
        this.requestUpdate();
    }

    properties() {
        return {
            prices: {},
            // discountAmount: 50,
            // discountPercent: 10,
            type: 'small', // ['small', 'big']
            linkHtml: '',
        };
    }

    get priceParts() {
        const parts = CurrencyFormatter.formatToParts(getSalePriceValue(this.prices));

        return html`
            <span class="price-parts"
                >${parts.map(({ type, value }) => html` <span class="type-${type}">${value}</span> `)}
                <price-asterisk></price-asterisk>
            </span>
        `;
    }

    get isShop() {
        return window.siteConfig().isShop;
    }

    template() {
        if (this.type === 'big') {
            return this.templateBig();
        }
        return this.templateSmall();
    }

    templateSmall() {
        const strikePrice = getFormattedStrikePrice(this.prices);
        return html`
            <div class="price-small text-sm whitespace-nowrap">
                <span class="price-with-symbol"
                    >${getFormattedSalePrice(this.prices)}<price-asterisk></price-asterisk
                ></span>
                ${!!strikePrice
                    ? html`
                          &nbsp;<del>${getFormattedStrikePrice(this.prices)}</del>
                          ${CurrencyFormatter.symbol()}
                          ${isStrikePrice(this.prices) ? i18n('RECOMMENDED_RETAIL_PRICE') : ''}
                      `
                    : ''}
            </div>
        `;
    }

    templateBig() {
        const strikePrice = getFormattedStrikePrice(this.prices);
        return html`
            <div class="price-big text-black text-left">
                <div class="flex">
                    ${!!strikePrice && strikePrice !== getFormattedSalePrice(this.salePrice)
                        ? html`
                              <div class="price-uvp">
                                  &nbsp;<del>${getFormattedStrikePrice(this.prices)}</del> ${CurrencyFormatter.symbol()}
                                  ${isStrikePrice(this.prices) ? i18n('RECOMMENDED_RETAIL_PRICE') : ''}
                              </div>
                              <div class="ml-2 price-saving">
                                  ${i18n('SAVING')} ${getFormattedDiscountPrice(this.prices)}
                              </div>
                          `
                        : ''}
                </div>
                <div class="price-with-symbol no-rfs-margin inline-flex">${this.priceParts}</div>
                <div class="block text-sm align-text-bottom md:inline-block md:ml-2">
                    <div class="leading-tight">
                        ${getFormattedBasePrice(this.prices)}
                        <br />
                        ${i18n('buybox.VAT')}
                        <br />
                        ${this.isShop && this.linkHtml
                            ? html`
                                  ${i18n('buybox.additionally')}
                                  <span class="cursor-pointer price-link inline-block"
                                      >${unsafeHTML(this.linkHtml)}</span
                                  >
                              `
                            : ''}
                    </div>
                </div>
            </div>
        `;
    }
}
